module.exports = __webpack_public_path__ + "6562fa470f42dd35ef1d540109243c19.png";